import { useEffect, useState } from 'react';
import './LeadsContent.css';
import { getAllLeads } from '../../utilities/api/leads';
import NewLead from '../../components/NewLead/NewLead';
import LeadsItem from '../../components/LeadsItem/LeadsItem';
import UploadSheet from '../../components/UploadSheet/UploadSheet';
import ConvertLead from '../../components/ConvertLead/ConvertLead';
import UpdateLead from '../../components/UpdateLead/UpdateLead';
import DeleteLead from '../../components/DeleteLead/DeleteLead';
import Tasks from '../../components/Tasks/Tasks';
import { getClientEmails } from '../../utilities/api/clients';
import LeadsFilter from '../../components/LeadsFilter/LeadsFilter';
import LeadReminders from '../../components/LeadReminders/LeadReminders';

export default function LeadsContent({ user, isMobile, toggleNotifications, leadsPreferences }) {
  const [loading, setLoading] = useState(false)
  const [leads, setLeads] = useState([])
  const [sortOrder, setSortOrder] = useState('desc')
  const [sortHeader, setSortHeader] = useState('createdAt')
  const [clientEmails, setClientEmails] = useState([])

  // console.log(leadsPreferences)

  const getLeads = async () => {
    setLoading(true)
    try {
      const allLeads = await getAllLeads()
      setLeads(allLeads.sort((a, b) => a[sortHeader] < b[sortHeader] ? 1 : -1))
    } catch (error) {
      console.log(error)
    }
    setLoading(false)
  }

  const updateLeads = (newLeads) => {
    newLeads.sort((a, b) => {
      if (sortOrder === 'asc') {
          return ((typeof(a[sortHeader])==='string' ? a[sortHeader].toLowerCase() : a[sortHeader]) > (typeof(b[sortHeader])==='string' ? b[sortHeader].toLowerCase() : b[sortHeader])) ? 1 : -1
      } else {
          return ((typeof(a[sortHeader])==='string' ? a[sortHeader].toLowerCase() : a[sortHeader]) < (typeof(b[sortHeader])==='string' ? b[sortHeader].toLowerCase() : b[sortHeader])) ? 1 : -1
      }
    });
    setLeads(newLeads)
  }

  const getUsedClientEmails = async () => {
    try {
      const emails = await getClientEmails()
      setClientEmails(emails)
    } catch (error) {
      console.log(error)
    }
  }
  // console.log(leads)

  const handleTableHeaderClick = (evt) => {
    const header = evt.target.id;
    const newSortOrder = sortOrder === 'asc' ? 'desc' : 'asc'
    setSortHeader(header);
    setSortOrder(newSortOrder);

    let sortedLeads = [...leads]
    sortedLeads.sort((a, b) => {
      if (newSortOrder === 'asc') {
        return ((typeof(a[header])==='string' ? a[header].toLowerCase() : a[header]) > (typeof(b[header])==='string' ? b[header].toLowerCase() : b[header])) ? 1 : -1;
      } else {
        return ((typeof(a[header])==='string' ? a[header].toLowerCase() : a[header]) < (typeof(b[header])==='string' ? b[header].toLowerCase() : b[header])) ? 1 : -1;
      }
    });
    setLeads(sortedLeads)
  }

  useEffect(() => {
    if (user.userType === 'admin' || user.userType === 'manager') {
      getLeads()
      getUsedClientEmails()
    }
    // eslint-disable-next-line
  },[])
  return (
    <div className='LeadsContent'>
      <div className='leadsHeadingContainer'>
        <div className='section1'>
          <div className='title'>
            Leads
          </div>
          <div className='tasks'>
            {/* <div className='tasksNotifications'>9</div> */}
            <button className='tasksButton' data-bs-toggle="modal" data-bs-target={`#tasksModal`} title='View Tasks'>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" fill="currentColor" className="bi bi-list-task" viewBox="0 0 16 16">
                <path fillRule="evenodd" d="M2 2.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM3 3H2v1h1z"/>
                <path d="M5 3.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5M5.5 7a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1zm0 4a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1z"/>
                <path fillRule="evenodd" d="M1.5 7a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5zM2 7h1v1H2zm0 3.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm1 .5H2v1h1z"/>
              </svg>
              { !isMobile &&
                <span>
                  &nbsp;&nbsp;Tasks
                </span>
              }
            </button>
            <Tasks user={user} section='leads' taskList={[]} />
          </div>
        </div>
        <div className='section2'>
            { ['admin', 'manager'].includes(user.userType) &&
            <>
            <button className='reminders' data-bs-toggle="modal" data-bs-target="#leadRemindersModal">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" fill="currentColor" className="bi bi-calendar-fill" viewBox="0 0 16 16">
                <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V5h16V4H0V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5"/>
              </svg>
            </button>
            <LeadReminders user={user} toggleNotifications={toggleNotifications} />
            <div className='uploadSheet'>
              <button className='uploadSheetButton' data-bs-toggle="modal" data-bs-target={`#uploadLeadsModal`} title='Upload Spreadsheet of Leads'>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" width="20px" fill='#FFFFFF'>
                  <path d="M 28.90625 1.96875 C 28.863281 1.976563 28.820313 1.988281 28.78125 2 L 11.5 2 C 9.585938 2 8 3.558594 8 5.46875 L 8 43.90625 C 8 46.160156 9.867188 48 12.125 48 L 37.875 48 C 40.132813 48 42 46.160156 42 43.90625 L 42 15.1875 C 42.027344 15.054688 42.027344 14.914063 42 14.78125 L 42 14.5 C 42.007813 14.234375 41.90625 13.972656 41.71875 13.78125 L 30.21875 2.28125 C 30.027344 2.09375 29.765625 1.992188 29.5 2 L 29.1875 2 C 29.097656 1.976563 29 1.964844 28.90625 1.96875 Z M 11.5 4 L 28 4 L 28 12.34375 C 28 14.355469 29.644531 16 31.65625 16 L 40 16 L 40 43.90625 C 40 45.074219 39.054688 46 37.875 46 L 12.125 46 C 10.945313 46 10 45.074219 10 43.90625 L 10 5.46875 C 10 4.644531 10.660156 4 11.5 4 Z M 30 4.9375 L 39.0625 14 L 31.65625 14 C 30.722656 14 30 13.277344 30 12.34375 Z M 17 24 L 17 38 L 33 38 L 33 24 Z M 19 26 L 24 26 L 24 28 L 19 28 Z M 26 26 L 31 26 L 31 28 L 26 28 Z M 19 30 L 24 30 L 24 32 L 19 32 Z M 26 30 L 31 30 L 31 32 L 26 32 Z M 19 34 L 24 34 L 24 36 L 19 36 Z M 26 34 L 31 34 L 31 36 L 26 36 Z"/>
                </svg>
                { !isMobile &&
                <span>
                  &nbsp;&nbsp;Upload Sheet
                </span>
                }
              </button>
              <UploadSheet user={user} getLeads={getLeads} toggleNotifications={toggleNotifications} />
            </div>
            <div className='createLead'>
              <button className='createLeadButton' data-bs-toggle="modal" data-bs-target={`#newLeadModal`} title='Add New Lead'>
                  <svg width="20" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect width="38" height="38" rx="10" fill="#FFFFFF" opacity='0.05'/>
                      <path d="M19 11V27V11ZM27 19H11H27Z" fill="#2173F0"/>
                      <path d="M19 11V27M27 19H11" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  { !isMobile &&
                  <span>
                    &nbsp;&nbsp;Add New Lead
                  </span>
                  }
              </button>
              <NewLead user={user} getLeads={getLeads} toggleNotifications={toggleNotifications} />
            </div>
            </>
            }
        </div>
      </div>
      {loading ?
      <div className='loading'>
        <div className="spinner-border" role="status"></div>
      </div>
      :
      <div className='leadsMainSection'>
        <div className='header'>
          <div className='title'>
            Leads List
          </div>
          <div className='filterContainer'>
            <LeadsFilter updateLeads={updateLeads} isMobile={isMobile} sortHeader={sortHeader} />
          </div>
        </div>
        <div className='leadsTable'>
          <table className=''>
            { leadsPreferences &&
            <>
            <thead>
              <tr>
                { !leadsPreferences.includes('leadName') &&
                <th id='leadName' onClick={handleTableHeaderClick} className='leadName' title='Click to sort by name'>
                  <div className='tableHeaderWithArrow'><div>Name&nbsp;&nbsp;</div>
                  { sortHeader==='leadName'?
                      <>
                      {sortOrder==='asc' ?
                      <div>
                          <div className='sortIndicatorActive'>&#9650;</div>
                          <div className='sortIndicatorInactive'>&#9660;</div>
                      </div>
                      : 
                      <div>
                          <div className='sortIndicatorInactive'>&#9650;</div>
                          <div className='sortIndicatorActive'>&#9660;</div>
                      </div>
                      }
                      </>
                      :
                      <div>
                          <div className='sortIndicatorInactive'>&#9650;</div>
                          <div className='sortIndicatorInactive'>&#9660;</div>
                      </div>
                  }
                  </div>
                </th>
                }
                { !leadsPreferences.includes('email') &&
                <th id='email' onClick={handleTableHeaderClick} className='email' title='Click to sort by email'>
                  <div className='tableHeaderWithArrow'><div>Email&nbsp;&nbsp;</div>
                  { sortHeader==='email'?
                      <>
                      {sortOrder==='asc' ?
                      <div>
                          <div className='sortIndicatorActive'>&#9650;</div>
                          <div className='sortIndicatorInactive'>&#9660;</div>
                      </div>
                      : 
                      <div>
                          <div className='sortIndicatorInactive'>&#9650;</div>
                          <div className='sortIndicatorActive'>&#9660;</div>
                      </div>
                      }
                      </>
                      :
                      <div>
                          <div className='sortIndicatorInactive'>&#9650;</div>
                          <div className='sortIndicatorInactive'>&#9660;</div>
                      </div>
                  }
                  </div>
                </th>
                }
                { !leadsPreferences.includes('status') &&
                <th id='status' onClick={handleTableHeaderClick} title='Click to sort by status'>
                  <div className='tableHeaderWithArrow'><div>Status&nbsp;&nbsp;</div>
                  { sortHeader==='status'?
                      <>
                      {sortOrder==='asc' ?
                      <div>
                          <div className='sortIndicatorActive'>&#9650;</div>
                          <div className='sortIndicatorInactive'>&#9660;</div>
                      </div>
                      : 
                      <div>
                          <div className='sortIndicatorInactive'>&#9650;</div>
                          <div className='sortIndicatorActive'>&#9660;</div>
                      </div>
                      }
                      </>
                      :
                      <div>
                          <div className='sortIndicatorInactive'>&#9650;</div>
                          <div className='sortIndicatorInactive'>&#9660;</div>
                      </div>
                  }
                  </div>
                </th>
                }
                { !leadsPreferences.includes('contactName') &&
                <th id='contactName' onClick={handleTableHeaderClick} title='Click to sort by contact name'>
                  <div className='tableHeaderWithArrow'><div>Contact&nbsp;&nbsp;</div>
                  { sortHeader==='contactName'?
                      <>
                      {sortOrder==='asc' ?
                      <div>
                          <div className='sortIndicatorActive'>&#9650;</div>
                          <div className='sortIndicatorInactive'>&#9660;</div>
                      </div>
                      : 
                      <div>
                          <div className='sortIndicatorInactive'>&#9650;</div>
                          <div className='sortIndicatorActive'>&#9660;</div>
                      </div>
                      }
                      </>
                      :
                      <div>
                          <div className='sortIndicatorInactive'>&#9650;</div>
                          <div className='sortIndicatorInactive'>&#9660;</div>
                      </div>
                  }
                  </div>
                </th>
                }
                { !leadsPreferences.includes('todos') &&
                <th id='todos' className=''>To-Do List</th>
                }
                { !leadsPreferences.includes('note') &&
                <th id='note'>Lead Notes</th>
                }
                { !leadsPreferences.includes('province') &&
                <th id='province' onClick={handleTableHeaderClick} title='Click to sort by province'>
                  <div className='tableHeaderWithArrow'><div>Province&nbsp;&nbsp;</div>
                  { sortHeader==='province'?
                      <>
                      {sortOrder==='asc' ?
                      <div>
                          <div className='sortIndicatorActive'>&#9650;</div>
                          <div className='sortIndicatorInactive'>&#9660;</div>
                      </div>
                      : 
                      <div>
                          <div className='sortIndicatorInactive'>&#9650;</div>
                          <div className='sortIndicatorActive'>&#9660;</div>
                      </div>
                      }
                      </>
                      :
                      <div>
                          <div className='sortIndicatorInactive'>&#9650;</div>
                          <div className='sortIndicatorInactive'>&#9660;</div>
                      </div>
                  }
                  </div>
                </th>
                }
                { !leadsPreferences.includes('phone') &&
                <th id='phone'>Phone</th>
                }
                { !leadsPreferences.includes('address') &&
                <th id='address'>Address</th>
                }
                { !leadsPreferences.includes('source') &&
                <th id='source' onClick={handleTableHeaderClick} title='Click to sort by source'>
                  <div className='tableHeaderWithArrow'><div>Source&nbsp;&nbsp;</div>
                  { sortHeader==='source'?
                      <>
                      {sortOrder==='asc' ?
                      <div>
                          <div className='sortIndicatorActive'>&#9650;</div>
                          <div className='sortIndicatorInactive'>&#9660;</div>
                      </div>
                      : 
                      <div>
                          <div className='sortIndicatorInactive'>&#9650;</div>
                          <div className='sortIndicatorActive'>&#9660;</div>
                      </div>
                      }
                      </>
                      :
                      <div>
                          <div className='sortIndicatorInactive'>&#9650;</div>
                          <div className='sortIndicatorInactive'>&#9660;</div>
                      </div>
                  }
                  </div>
                </th>
                }
                { !leadsPreferences.includes('createdAt') &&
                <th id='createdAt' onClick={handleTableHeaderClick} className='createdAt' title='Click to sort by creation date'>
                  <div className='tableHeaderWithArrow'><div>Creation&nbsp;&nbsp;</div>
                  { sortHeader==='createdAt'?
                      <>
                      {sortOrder==='asc' ?
                      <div>
                          <div className='sortIndicatorActive'>&#9650;</div>
                          <div className='sortIndicatorInactive'>&#9660;</div>
                      </div>
                      : 
                      <div>
                          <div className='sortIndicatorInactive'>&#9650;</div>
                          <div className='sortIndicatorActive'>&#9660;</div>
                      </div>
                      }
                      </>
                      :
                      <div>
                          <div className='sortIndicatorInactive'>&#9650;</div>
                          <div className='sortIndicatorInactive'>&#9660;</div>
                      </div>
                  }
                  </div>
                </th>
                }
                { !leadsPreferences.includes('updatedAt') &&
                <th id='updatedAt' onClick={handleTableHeaderClick} className='updatedAt' title='Click to sort by last update date'>
                  <div className='tableHeaderWithArrow'><div>Last Update&nbsp;&nbsp;</div>
                  { sortHeader==='updatedAt'?
                      <>
                      {sortOrder==='asc' ?
                      <div>
                          <div className='sortIndicatorActive'>&#9650;</div>
                          <div className='sortIndicatorInactive'>&#9660;</div>
                      </div>
                      : 
                      <div>
                          <div className='sortIndicatorInactive'>&#9650;</div>
                          <div className='sortIndicatorActive'>&#9660;</div>
                      </div>
                      }
                      </>
                      :
                      <div>
                          <div className='sortIndicatorInactive'>&#9650;</div>
                          <div className='sortIndicatorInactive'>&#9660;</div>
                      </div>
                  }
                  </div>
                </th>
                }
                <th id='actions' className='actions'>Actions</th>
              </tr>
              </thead>
            <tbody>
              { leads.length === 0 ?
              <tr>
                <td colSpan='12' className='noLeads text-center'>No Leads Found</td>
              </tr>
              :
              <>
              {leads.map(lead => (
                <LeadsItem user={user} key={lead._id} leadItem={lead} isMobile={isMobile} leadsPreferences={leadsPreferences} />
              ))}
              </>
              }
              
            </tbody>
            </>
            }
          </table>
          <div>
          { leads.map(lead => (
            <div key={lead._id}>
              <ConvertLead user={user} leadItem={lead} getLeads={getLeads} clientEmails={clientEmails} toggleNotifications={toggleNotifications} />
              <UpdateLead user={user} leadItem={lead} getLeads={getLeads} toggleNotifications={toggleNotifications} />
              <DeleteLead user={user} leadItem={lead} getLeads={getLeads} toggleNotifications={toggleNotifications} />
            </div>
          ))}
          </div>
        </div>
        <div className='footer'>
          <div>
            page count
          </div>
          <div>
            toggle
          </div>
        </div>
      </div>
      }
    </div>
  )
}
